(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["damit-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('damit-calculator')) {
    class DamitCalculator extends HTMLElement {
      static cartBusy = false;
      static cartWarning(detail, fallback) {
        const partial = detail.match(/Only\s+(\d+)\s+items?\s+were added/i);
        if (partial) return 'Only ' + partial[1] + ' item' + (partial[1] === '1' ? '' : 's') + ' added due to stock availability.';
        if (/maximum quantity.*already in your cart/i.test(detail)) return 'Maximum quantity already in your cart.';
        if (/sold out/i.test(detail)) return 'This product is sold out.';
        return fallback;
      }
      static normalise(value) {
        const integer = Math.round(value);
        return Math.abs(value - integer) <= Number.EPSILON * 32 * Math.max(1, Math.abs(value)) ? integer : value;
      }
      static packs(litres) {
        if (!Number.isFinite(litres) || litres <= 0 || litres > 100000) throw new RangeError('Invalid litres');
        // Small jobs may use 1 L packs, but never four bottles.
        litres = this.normalise(litres);
        if (litres <= 3) return [{ size: 1, quantity: Math.ceil(litres) }];
        if (litres <= 5) return [{ size: 5, quantity: 1 }];
        if (litres <= 8) return [{ size: 5, quantity: 1 }, { size: 1, quantity: Math.ceil(this.normalise(litres - 5)) }];
        if (litres <= 10) return [{ size: 5, quantity: 2 }];
        // For an entire job above 10 L, use only 15 L and 5 L packs.
        const fifteens = Math.floor(this.normalise(litres / 15));
        const remaining = this.normalise(litres - fifteens * 15);
        if (remaining > 10) return [{ size: 15, quantity: fifteens + 1 }];
        const fives = Math.ceil(this.normalise(remaining / 5));
        return [{ size: 15, quantity: fifteens }, { size: 5, quantity: fives }].filter(item => item.quantity > 0);
      }
      connectedCallback() {
        if (this.listeners) return;
        this.listeners = new AbortController();
        this.messages = JSON.parse(this.dataset.messages);
        this.form = this.querySelector('[data-form]');
        this.controls = this.querySelector('[data-controls]');
        this.addButton = this.querySelector('[data-add-cart]');
        this.status = this.querySelector('[data-status]');
        this.rows = this.querySelector('[data-rows]');
        this.products = new Map([...this.querySelectorAll('[data-product]')].map(node => [Number(node.dataset.size), node]));
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 1 });
        const options = { signal: this.listeners.signal };
        this.form.addEventListener('submit', event => { event.preventDefault(); if (!this.busy) this.calculate(); }, options);
        this.form.addEventListener('input', () => { if (!this.busy) this.invalidate(); }, options);
        this.form.addEventListener('change', () => { if (!this.busy) { this.syncPanels(); this.invalidate(); } }, options);
        this.form.addEventListener('reset', event => {
          if (this.busy) { event.preventDefault(); return; }
          setTimeout(() => { if (!this.isConnected) return; this.rows.replaceChildren(); this.addWall(); this.syncPanels(); this.invalidate(); }, 0);
        }, options);
        this.addEventListener('click', event => {
          if (this.busy) return;
          const remove = event.target.closest('[data-remove-wall]');
          if (event.target.closest('[data-add-wall]')) this.addWall(true);
          if (remove && this.rows.children.length > 1) {
            remove.closest('.aq-damit__wall').remove(); this.numberWalls(); this.invalidate(); this.querySelector('[data-add-wall]').focus();
          }
        }, options);
        this.addButton.addEventListener('click', () => this.addToCart(), options);
        window.addEventListener('pageshow', event => {
          if (event.persisted) { this.busy = false; this.reviewRequired = true; this.controls.disabled = false; this.invalidate(); this.status.textContent = this.messages.uncertain; }
        }, options);
        if (!this.rows.children.length) this.addWall();
        this.controls.disabled = Boolean(this.busy);
        this.syncPanels();
      }
      disconnectedCallback() { this.listeners?.abort(); this.listeners = null; }
      syncPanels() {
        const whole = this.querySelector('[data-job]:checked').value === 'whole';
        const shape = this.querySelector('[data-shape]').value;
        const dimensions = this.querySelector('[data-method]').value === 'dimensions';
        const irregular = whole && shape === 'irregular';
        for (const [name, visible] of Object.entries({ whole, wall: !whole, rectangle: whole && shape === 'rectangle', circle: whole && shape === 'circle', irregular, dimensions: irregular && dimensions, area: irregular && !dimensions })) {
          const panel = this.querySelector(`[data-panel="${name}"]`); panel.hidden = !visible; panel.disabled = !visible;
        }
      }
      addWall(focus = false) {
        if (this.rows.children.length >= 100) return;
        this.rows.append(this.querySelector('[data-wall-template]').content.cloneNode(true));
        this.numberWalls(); this.invalidate();
        if (focus) this.rows.lastElementChild.querySelector('input').focus();
      }
      numberWalls() {
        [...this.rows.children].forEach((row, index) => {
          row.querySelector('[data-wall-number]').textContent = index + 1;
          row.querySelector('[data-remove-wall]').disabled = this.rows.children.length === 1;
        });
        this.querySelector('[data-add-wall]').disabled = this.rows.children.length >= 100;
      }
      showMeasurementError(message) {
        const error = this.querySelector('[data-measurement-error]');
        error.textContent = message; error.hidden = false;
        this.querySelector('[data-measurements]').setAttribute('aria-invalid', 'true');
        error.focus();
      }
      invalidate() {
        const error = this.querySelector('[data-measurement-error]');
        error.hidden = true; error.textContent = '';
        this.querySelector('[data-measurements]').removeAttribute('aria-invalid');
        this.status.classList.remove('aq-damit__sr-only');
        this.addedRecommendation = false;
        this.recommendation = null;
        this.addButton.disabled = true;
        this.querySelector('[data-result]').hidden = true;
        this.querySelector('[data-placeholder]').hidden = false;
        if (!this.reviewRequired) this.status.textContent = '';
      }
      display(value) { return value > 0 && value < .05 ? this.messages.small : this.formatter.format(value); }
      calculate() {
        this.invalidate();
        if (!this.form.reportValidity()) { this.status.textContent = this.messages.invalid; return; }
        const value = selector => this.querySelector(selector).valueAsNumber;
        const wall = this.querySelector('[data-job]:checked').value === 'wall';
        const shape = this.querySelector('[data-shape]').value;
        let total = 0;
        if (wall) total = value('[data-wall-length]') * 20;
        else if (shape === 'rectangle') total = value('[data-rect-length]') * value('[data-rect-width]');
        else if (shape === 'circle') total = .785 * value('[data-diameter]') ** 2;
        else if (this.querySelector('[data-method]').value === 'area') total = value('[data-area]');
        else for (const row of this.rows.children) total += row.querySelector('[data-length]').valueAsNumber * row.querySelector('[data-height]').valueAsNumber;
        if (!Number.isFinite(total) || total <= 0 || total > 1000000) { this.showMeasurementError(this.messages.limit); return; }
        const litres = total / 10;
        this.querySelector('[data-total]').textContent = this.display(total) + ' m²';
        this.querySelector('[data-litres]').textContent = `${this.display(litres)} L`;
        const packs = DamitCalculator.packs(litres);
        for (const size of [15, 5, 1]) this.querySelector('[data-count-' + size + ']').textContent = packs.find(pack => pack.size === size)?.quantity || 0;
        const needed = packs.map(pack => this.products.get(pack.size));
        const ids = needed.map(product => product.dataset.id);
        let valid = ids.every(Boolean) && new Set(ids).size === ids.length && needed.every(product => product.dataset.configured === 'true');
        let reason = valid ? '' : this.messages.configuration;
        const list = this.querySelector('[data-pack-list]'); list.replaceChildren();
        const items = [];
        for (const pack of packs) {
          const product = this.products.get(pack.size);
          const node = product.content.cloneNode(true);
          const data = product.dataset;
          const min = Number(data.min); const increment = Number(data.increment); const max = data.max ? Number(data.max) : Infinity;
          const available = data.available === 'true' && pack.quantity >= min && pack.quantity <= max && pack.quantity % increment === 0;
          node.querySelector('[data-quantity]').textContent = pack.quantity;
          if (!available) { valid = false; reason ||= this.messages.unavailable; node.querySelector('[data-pack-status]').textContent = this.messages.unavailable; }
          list.append(node);
          items.push({ id: Number(data.id), quantity: pack.quantity });
        }
        this.querySelector('[data-supplied]').textContent = `${this.formatter.format(packs.reduce((sum, pack) => sum + pack.size * pack.quantity, 0))} L`;
        this.querySelector('[data-result]').hidden = false;
        this.querySelector('[data-placeholder]').hidden = true;
        this.recommendation = valid ? items : null;
        this.addButton.disabled = !valid || Boolean(this.reviewRequired);
        if (!this.reviewRequired) {
          this.status.textContent = reason || this.messages.calculated.replace('[litres]', this.display(litres));
          this.status.classList.toggle('aq-damit__sr-only', !reason);
        }
        const heading = this.querySelector('[data-result-heading]');
        heading.focus({ preventScroll: true });
        if (window.matchMedia('(max-width: 767px)').matches) heading.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
      async addToCart() {
        if (!this.recommendation || this.busy || this.reviewRequired || DamitCalculator.cartBusy) return;
        DamitCalculator.cartBusy = true; this.busy = true;
        this.addButton.disabled = true; this.controls.disabled = true;
        this.status.classList.remove('aq-damit__sr-only');
        this.setAttribute('aria-busy', 'true'); this.status.textContent = this.messages.adding;
        let sent = false;
        try {
          const drawer = document.querySelector('m-cart-drawer');
          const cartItems = drawer?.querySelector('m-cart-items');
          if (typeof drawer?.open !== 'function' || typeof cartItems?.onCartRefresh !== 'function') {
            this.status.textContent = this.messages.drawerUnavailable; return;
          }
          sent = true;
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin', signal: AbortSignal.timeout(20000),
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: this.recommendation })
          });
          const result = await response.json();
          if (!response.ok || result.status || result.errors) {
            this.reviewRequired = true;
            this.status.textContent = DamitCalculator.cartWarning(typeof result.description === 'string' ? result.description : '', this.messages.rejected) + ' Check your cart.';
          } else {
            this.addedRecommendation = true;
            this.status.textContent = this.messages.added;
          }
        } catch (error) {
          this.reviewRequired = sent;
          this.status.textContent = sent ? this.messages.uncertain : this.messages.drawerUnavailable;
        } finally {
          // Reuse the original theme refresh event, including partial-stock responses.
          // Minimog refreshes its own contents and opens only once the refresh completes.
          if (sent) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          DamitCalculator.cartBusy = false; this.busy = false; this.controls.disabled = false;
          this.removeAttribute('aria-busy'); this.syncPanels();
          this.addButton.disabled = Boolean(this.reviewRequired || this.addedRecommendation) || !this.recommendation;
        }
      }
    }
    customElements.define('damit-calculator', DamitCalculator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sealit-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sealit-calculator')) {
    class SealitCalculator extends HTMLElement {
      static cartBusy = false;
      static cartWarning(detail, fallback) {
        const partial = detail.match(/Only\s+(\d+)\s+items?\s+were added/i);
        if (partial) return 'Only ' + partial[1] + ' item' + (partial[1] === '1' ? '' : 's') + ' added due to stock availability.';
        if (/maximum quantity.*already in your cart/i.test(detail)) return 'Maximum quantity already in your cart.';
        if (/sold out/i.test(detail)) return 'This product is sold out.';
        return fallback;
      }
      static normalise(value) {
        const integer = Math.round(value);
        return Math.abs(value - integer) <= Number.EPSILON * 32 * Math.max(1, Math.abs(value)) ? integer : value;
      }
      static packs(litres) {
        if (!Number.isFinite(litres) || litres <= 0 || litres > 200000) throw new RangeError('Invalid litres');
        let twenties = Math.floor(this.normalise(litres / 20));
        let remaining = this.normalise(litres - twenties * 20);
        if (remaining > 15) return [{ size: 20, quantity: twenties + 1 }];
        const fives = Math.floor(this.normalise(remaining / 5));
        const ones = Math.ceil(this.normalise(remaining - fives * 5));
        return [{ size: 20, quantity: twenties }, { size: 5, quantity: fives }, { size: 1, quantity: ones }].filter(item => item.quantity > 0);
      }
      connectedCallback() {
        if (this.listeners) return;
        this.listeners = new AbortController();
        this.messages = JSON.parse(this.dataset.messages);
        this.form = this.querySelector('[data-form]');
        this.controls = this.querySelector('[data-controls]');
        this.addButton = this.querySelector('[data-add-cart]');
        this.status = this.querySelector('[data-status]');
        this.rows = this.querySelector('[data-rows]');
        this.products = new Map([...this.querySelectorAll('[data-product]')].map(node => [Number(node.dataset.size), node]));
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 1 });
        const options = { signal: this.listeners.signal };
        this.form.addEventListener('submit', event => { event.preventDefault(); if (!this.busy) this.calculate(); }, options);
        this.form.addEventListener('input', () => { if (!this.busy) this.invalidate(); }, options);
        this.form.addEventListener('change', () => { if (!this.busy) { this.syncPanels(); this.invalidate(); } }, options);
        this.form.addEventListener('reset', event => {
          if (this.busy) { event.preventDefault(); return; }
          setTimeout(() => { if (!this.isConnected) return; this.rows.replaceChildren(); this.addWall(); this.syncPanels(); this.invalidate(); }, 0);
        }, options);
        this.addEventListener('click', event => {
          if (this.busy) return;
          const remove = event.target.closest('[data-remove-wall]');
          if (event.target.closest('[data-add-wall]')) this.addWall(true);
          if (remove && this.rows.children.length > 1) {
            remove.closest('.aq-sealit__wall').remove(); this.numberWalls(); this.invalidate(); this.querySelector('[data-add-wall]').focus();
          }
        }, options);
        this.addButton.addEventListener('click', () => this.addToCart(), options);
        window.addEventListener('pageshow', event => {
          if (event.persisted) { this.busy = false; this.reviewRequired = true; this.controls.disabled = false; this.invalidate(); this.status.textContent = this.messages.uncertain; }
        }, options);
        if (!this.rows.children.length) this.addWall();
        this.controls.disabled = Boolean(this.busy);
        this.syncPanels();
      }
      disconnectedCallback() { this.listeners?.abort(); this.listeners = null; }
      syncPanels() {
        const walls = this.querySelector('[data-job]:checked').value === 'walls';
        const dimensions = this.querySelector('[data-method]').value === 'dimensions';
        for (const [name, visible] of Object.entries({ walls, dam: !walls, dimensions: walls && dimensions, area: walls && !dimensions })) {
          const panel = this.querySelector(`[data-panel="${name}"]`); panel.hidden = !visible; panel.disabled = !visible;
        }
      }
      addWall(focus = false) {
        if (this.rows.children.length >= 100) return;
        this.rows.append(this.querySelector('[data-wall-template]').content.cloneNode(true));
        this.numberWalls(); this.invalidate();
        if (focus) this.rows.lastElementChild.querySelector('input').focus();
      }
      numberWalls() {
        [...this.rows.children].forEach((row, index) => {
          row.querySelector('[data-wall-number]').textContent = index + 1;
          row.querySelector('[data-remove-wall]').disabled = this.rows.children.length === 1;
        });
        this.querySelector('[data-add-wall]').disabled = this.rows.children.length >= 100;
      }
      invalidate() {
        this.status.classList.remove('aq-sealit__sr-only');
        this.addedRecommendation = false;
        this.recommendation = null;
        this.addButton.disabled = true;
        this.querySelector('[data-result]').hidden = true;
        this.querySelector('[data-placeholder]').hidden = false;
        if (!this.reviewRequired) this.status.textContent = '';
      }
      display(value) { return value > 0 && value < .05 ? this.messages.small : this.formatter.format(value); }
      calculate() {
        this.invalidate();
        if (!this.form.reportValidity()) { this.status.textContent = this.messages.invalid; return; }
        const dam = this.querySelector('[data-job]:checked').value === 'dam';
        const value = selector => this.querySelector(selector).valueAsNumber;
        let floor = 0;
        let wall = 0;
        if (dam) {
          const diameter = value('[data-diameter]');
          floor = .785 * diameter * diameter;
          wall = 3.14 * diameter * value('[data-dam-height]');
        } else if (this.querySelector('[data-method]').value === 'area') wall = value('[data-area]');
        else for (const row of this.rows.children) wall += row.querySelector('[data-length]').valueAsNumber * row.querySelector('[data-height]').valueAsNumber;
        const total = floor + wall;
        if (!Number.isFinite(total) || total <= 0 || total > 1000000) { this.status.textContent = this.messages.limit; return; }
        const litres = total / 5;
        this.querySelector('[data-floor-row]').hidden = !dam;
        for (const [key, amount] of Object.entries({ floor, wall, total })) this.querySelector(`[data-${key}]`).textContent = `${this.display(amount)} m²`;
        this.querySelector('[data-litres]').textContent = `${this.display(litres)} L`;
        const packs = SealitCalculator.packs(litres);
        const ids = [...this.products.values()].map(product => product.dataset.id);
        let valid = ids.every(Boolean) && new Set(ids).size === 3 && [...this.products.values()].every(product => product.dataset.configured === 'true');
        let reason = valid ? '' : this.messages.configuration;
        const list = this.querySelector('[data-pack-list]'); list.replaceChildren();
        const items = [];
        for (const pack of packs) {
          const product = this.products.get(pack.size);
          const node = product.content.cloneNode(true);
          const data = product.dataset;
          const min = Number(data.min); const increment = Number(data.increment); const max = data.max ? Number(data.max) : Infinity;
          const available = data.available === 'true' && pack.quantity >= min && pack.quantity <= max && pack.quantity % increment === 0;
          node.querySelector('[data-quantity]').textContent = pack.quantity;
          if (!available) { valid = false; reason ||= this.messages.unavailable; node.querySelector('[data-pack-status]').textContent = this.messages.unavailable; }
          list.append(node);
          items.push({ id: Number(data.id), quantity: pack.quantity });
        }
        this.querySelector('[data-supplied]').textContent = `${this.formatter.format(packs.reduce((sum, pack) => sum + pack.size * pack.quantity, 0))} L`;
        this.querySelector('[data-result]').hidden = false;
        this.querySelector('[data-placeholder]').hidden = true;
        this.recommendation = valid ? items : null;
        this.addButton.disabled = !valid || Boolean(this.reviewRequired);
        if (!this.reviewRequired) {
          this.status.textContent = reason || this.messages.calculated.replace('[litres]', this.display(litres));
          this.status.classList.toggle('aq-sealit__sr-only', !reason);
        }
        const heading = this.querySelector('[data-result-heading]');
        heading.focus({ preventScroll: true });
        if (window.matchMedia('(max-width: 767px)').matches) heading.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
      async addToCart() {
        if (!this.recommendation || this.busy || this.reviewRequired || SealitCalculator.cartBusy) return;
        SealitCalculator.cartBusy = true; this.busy = true;
        this.addButton.disabled = true; this.controls.disabled = true;
        this.status.classList.remove('aq-sealit__sr-only');
        this.setAttribute('aria-busy', 'true'); this.status.textContent = this.messages.adding;
        let sent = false;
        try {
          const drawer = document.querySelector('m-cart-drawer');
          const cartItems = drawer?.querySelector('m-cart-items');
          if (typeof drawer?.open !== 'function' || typeof cartItems?.onCartRefresh !== 'function') {
            this.status.textContent = this.messages.drawerUnavailable; return;
          }
          sent = true;
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin', signal: AbortSignal.timeout(20000),
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: this.recommendation })
          });
          const result = await response.json();
          if (!response.ok || result.status || result.errors) {
            this.reviewRequired = true;
            this.status.textContent = SealitCalculator.cartWarning(typeof result.description === 'string' ? result.description : '', this.messages.rejected) + ' Check your cart.';
          } else {
            this.addedRecommendation = true;
            this.status.textContent = this.messages.added;
          }
        } catch (error) {
          this.reviewRequired = sent;
          this.status.textContent = sent ? this.messages.uncertain : this.messages.drawerUnavailable;
        } finally {
          // Reuse the original theme refresh event, including partial-stock responses.
          // Minimog refreshes its own contents and opens only once the refresh completes.
          if (sent) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          SealitCalculator.cartBusy = false; this.busy = false; this.controls.disabled = false;
          this.removeAttribute('aria-busy'); this.syncPanels();
          this.addButton.disabled = Boolean(this.reviewRequired || this.addedRecommendation) || !this.recommendation;
        }
      }
    }
    customElements.define('sealit-calculator', SealitCalculator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stickit-calculator"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('stickit-calculator')) {
    class StickitCalculator extends HTMLElement {
      static cartBusy = false;
      static cartWarning(detail, fallback) {
        const partial = detail.match(/Only\s+(\d+)\s+items?\s+were added/i);
        if (partial) return 'Only ' + partial[1] + ' item' + (partial[1] === '1' ? '' : 's') + ' added due to stock availability.';
        if (/maximum quantity.*already in your cart/i.test(detail)) return 'Maximum quantity already in your cart.';
        if (/sold out/i.test(detail)) return 'This product is sold out.';
        return fallback;
      }
      static normalise(value) {
        const integer = Math.round(value);
        return Math.abs(value - integer) <= Number.EPSILON * 32 * Math.max(1, Math.abs(value)) ? integer : value;
      }
      static roundedKg(rawKg) {
        if (!Number.isFinite(rawKg) || rawKg <= 0 || rawKg > 200000) throw new RangeError('Invalid kilograms');
        return Math.ceil(this.normalise(rawKg * 2)) / 2;
      }
      static packs(rawKg, useFive = false) {
        const kg = this.roundedKg(rawKg);
        const fives = useFive ? Math.floor(kg / 5) : 0;
        return [{ size: 5, quantity: fives }, { size: 1, quantity: Math.ceil(kg - fives * 5) }].filter(pack => pack.quantity > 0);
      }
      connectedCallback() {
        if (this.listeners) return;
        this.listeners = new AbortController();
        this.messages = JSON.parse(this.dataset.messages);
        this.form = this.querySelector('[data-form]'); this.controls = this.querySelector('[data-controls]');
        this.addButton = this.querySelector('[data-add-cart]'); this.status = this.querySelector('[data-status]'); this.rows = this.querySelector('[data-rows]');
        this.products = new Map([...this.querySelectorAll('[data-product]')].map(node => [Number(node.dataset.size), node]));
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 });
        this.pumpControls = this.querySelector('[data-pumps]');
        this.pumpControls.hidden = this.querySelectorAll('[data-pump]').length <= 1;
        this.pumpControls.addEventListener('change', () => { if (!this.busy) this.updatePurchase(); }, { signal: this.listeners.signal });
        const options = { signal: this.listeners.signal };
        this.form.addEventListener('submit', event => { event.preventDefault(); if (!this.busy) this.calculate(); }, options);
        this.form.addEventListener('input', () => { if (!this.busy) this.invalidate(); }, options);
        this.form.addEventListener('change', () => { if (!this.busy) { this.syncPanels(); this.invalidate(); } }, options);
        this.form.addEventListener('reset', event => {
          if (this.busy) { event.preventDefault(); return; }
          setTimeout(() => { if (!this.isConnected) return; this.rows.replaceChildren(); this.addRectangle(); this.syncPanels(); this.invalidate(); this.querySelector('[data-pump][value=""]').checked = true; this.updatePurchase(); }, 0);
        }, options);
        this.addEventListener('click', event => {
          if (this.busy) return;
          if (event.target.closest('[data-add-rectangle]')) this.addRectangle(true);
          const remove = event.target.closest('[data-remove-rectangle]');
          if (remove && this.rows.children.length > 1) { remove.closest('fieldset').remove(); this.numberRectangles(); this.invalidate(); this.querySelector('[data-add-rectangle]').focus(); }
        }, options);
        this.addButton.addEventListener('click', () => this.addToCart(), options);
        window.addEventListener('pageshow', event => { if (event.persisted) { this.busy = false; this.reviewRequired = true; this.controls.disabled = false; this.invalidate(); this.status.textContent = this.messages.uncertain; } }, options);
        if (!this.rows.children.length) this.addRectangle();
        this.controls.disabled = Boolean(this.busy); this.syncPanels();
      }
      disconnectedCallback() { this.listeners?.abort(); this.listeners = null; }
      syncPanels() {
        const regular = this.querySelector('[data-shape]').value === 'regular';
        const method = this.querySelector('[data-method]').value;
        const visibility = { regular, irregular: !regular, direct: !regular && method === 'direct', rectangles: !regular && method === 'rectangles', bounding: !regular && method === 'bounding', hollow: this.querySelector('[data-treatment]').value === 'hollow' };
        for (const [name, visible] of Object.entries(visibility)) { const panel = this.querySelector('[data-panel="' + name + '"]'); panel.hidden = !visible; panel.disabled = !visible; }
      }
      addRectangle(focus = false) {
        if (this.rows.children.length >= 100) return;
        this.rows.append(this.querySelector('[data-rectangle-template]').content.cloneNode(true)); this.numberRectangles(); this.invalidate();
        if (focus) this.rows.lastElementChild.querySelector('input').focus();
      }
      numberRectangles() {
        [...this.rows.children].forEach((row, index) => { row.querySelector('[data-rectangle-number]').textContent = index + 1; row.querySelector('[data-remove-rectangle]').disabled = this.rows.children.length === 1; });
        this.querySelector('[data-add-rectangle]').disabled = this.rows.children.length >= 100;
      }
      invalidate() {
        this.status.classList.remove('aq-stickit__sr-only'); this.addedRecommendation = false; this.refillRecommendation = null; this.recommendation = null; this.addButton.disabled = true;
        this.querySelector('[data-result]').hidden = true; this.querySelector('[data-placeholder]').hidden = false;
        if (!this.reviewRequired) this.status.textContent = '';
      }
      display(value) { return value > 0 && value < .005 ? this.messages.small : this.formatter.format(value); }
      calculate() {
        this.invalidate();
        if (!this.form.reportValidity()) { this.status.textContent = this.messages.invalid; return; }
        const value = selector => this.querySelector(selector).valueAsNumber;
        let measured = 0;
        if (this.querySelector('[data-shape]').value === 'regular') {
          const count = value('[data-tile-count]');
          if (!Number.isSafeInteger(count)) { this.status.textContent = this.messages.invalid; return; }
          measured = value('[data-tile-width]') * value('[data-tile-height]') * count / 1000000;
        } else {
          const method = this.querySelector('[data-method]').value;
          if (method === 'direct') measured = value('[data-area]');
          else if (method === 'bounding') measured = value('[data-box-length]') * value('[data-box-width]') * value('[data-tiled-percent]') / 100;
          else for (const row of this.rows.children) measured += row.querySelector('[data-rectangle-width]').valueAsNumber * row.querySelector('[data-rectangle-height]').valueAsNumber;
        }
        const factor = this.querySelector('[data-treatment]').value === 'hollow' ? value('[data-hollow-percent]') / 100 : 1;
        const total = measured * factor;
        if (!Number.isFinite(measured) || measured <= 0 || measured > 1000000 || !Number.isFinite(total) || total <= 0) { this.status.textContent = this.messages.limit; return; }
        const rawKg = total / (this.querySelector('[data-surface]:checked').value === 'floor' ? 5 : 10);
        const roundedKg = StickitCalculator.roundedKg(rawKg);
        this.querySelector('[data-measured]').textContent = this.display(measured) + ' m²';
        this.querySelector('[data-total]').textContent = this.display(total) + ' m²';
        this.querySelector('[data-raw]').textContent = this.display(rawKg) + ' kg';
        this.querySelector('[data-kg]').textContent = this.formatter.format(roundedKg) + ' kg';
        const five = this.products.get(5);
        const useFive = five?.dataset.configured === 'true' && five.dataset.available === 'true';
        const packs = StickitCalculator.packs(rawKg, useFive);
        const ids = [...this.products.values()].map(product => product.dataset.id);
        let valid = true;
        let reason = '';
        const list = this.querySelector('[data-pack-list]'); list.replaceChildren();
        const items = [];
        for (const pack of packs) {
          const product = this.products.get(pack.size);
          const node = product.content.cloneNode(true);
          const data = product.dataset;
          const min = Number(data.min); const increment = Number(data.increment); const max = data.max ? Number(data.max) : Infinity;
          const configured = data.configured === 'true' && data.id && ids.filter(id => id === data.id).length === 1;
          if (!configured) { valid = false; reason = this.messages.configuration; }
          const available = data.available === 'true' && pack.quantity >= min && pack.quantity <= max && pack.quantity % increment === 0;
          node.querySelector('[data-quantity]').textContent = pack.quantity;
          if (!available) { valid = false; reason ||= this.messages.unavailable; node.querySelector('[data-pack-status]').textContent = this.messages.unavailable; }
          list.append(node);
          items.push({ id: Number(data.id), quantity: pack.quantity });
        }
        this.querySelector('[data-supplied]').textContent = `${this.formatter.format(packs.reduce((sum, pack) => sum + pack.size * pack.quantity, 0))} kg`;
        this.querySelector('[data-result]').hidden = false;
        this.querySelector('[data-placeholder]').hidden = true;
        this.refillRecommendation = valid ? items : null;
        this.updatePurchase();
        this.addButton.disabled = !this.recommendation || Boolean(this.reviewRequired);
        if (!this.reviewRequired) {
          this.status.textContent = reason || this.messages.calculated.replace('[kg]', this.formatter.format(roundedKg));
          this.status.classList.toggle('aq-stickit__sr-only', !reason);
        }
        const heading = this.querySelector('[data-result-heading]');
        heading.focus({ preventScroll: true });
        if (window.matchMedia('(max-width: 767px)').matches) heading.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
      updatePurchase() {
        this.recommendation = this.refillRecommendation ? this.refillRecommendation.map(item => ({ ...item })) : null;
        const pumpId = Number(this.querySelector('[data-pump]:checked')?.value);
        if (this.recommendation && pumpId) {
          if (this.recommendation.some(item => item.id === pumpId)) { this.recommendation = null; this.status.classList.remove('aq-stickit__sr-only'); this.status.textContent = this.messages.configuration; }
          else this.recommendation.push({ id: pumpId, quantity: 1 });
        }
        this.addButton.textContent = pumpId ? 'Add refills and selected pump' : 'Add recommended refills';
        this.addButton.disabled = !this.recommendation || Boolean(this.reviewRequired || this.addedRecommendation || this.busy);
      }
      async addToCart() {
        if (!this.recommendation || this.busy || this.reviewRequired || StickitCalculator.cartBusy) return;
        StickitCalculator.cartBusy = true; this.busy = true;
        this.addButton.disabled = true; this.controls.disabled = true; this.pumpControls.disabled = true;
        this.status.classList.remove('aq-stickit__sr-only');
        this.setAttribute('aria-busy', 'true'); this.status.textContent = this.messages.adding;
        let sent = false;
        try {
          const drawer = document.querySelector('m-cart-drawer');
          const cartItems = drawer?.querySelector('m-cart-items');
          if (typeof drawer?.open !== 'function' || typeof cartItems?.onCartRefresh !== 'function') {
            this.status.textContent = this.messages.drawerUnavailable; return;
          }
          sent = true;
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin', signal: AbortSignal.timeout(20000),
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: this.recommendation })
          });
          const result = await response.json();
          if (!response.ok || result.status || result.errors) {
            this.reviewRequired = true;
            this.status.textContent = StickitCalculator.cartWarning(typeof result.description === 'string' ? result.description : '', this.messages.rejected) + ' Check your cart.';
          } else {
            this.addedRecommendation = true;
            this.status.textContent = this.messages.added;
          }
        } catch (error) {
          this.reviewRequired = sent;
          this.status.textContent = sent ? this.messages.uncertain : this.messages.drawerUnavailable;
        } finally {
          // Reuse the original theme refresh event, including partial-stock responses.
          // Minimog refreshes its own contents and opens only once the refresh completes.
          if (sent) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          StickitCalculator.cartBusy = false; this.busy = false; this.controls.disabled = false; this.pumpControls.disabled = false;
          this.removeAttribute('aria-busy'); this.syncPanels();
          this.addButton.disabled = Boolean(this.reviewRequired || this.addedRecommendation) || !this.recommendation;
        }
      }
    }
    customElements.define('stickit-calculator', StickitCalculator);
  }


  } catch(e) { console.error(e); }
})();
})();
